import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-mask"
export default class extends Controller {
  connect() {
    // Format the phone number on connect if it has a value
    if (this.element.value) {
      this.format();
    }
  }

  format() {
    // Get the input value
    let value = this.element.value;

    // Remove all non-digit characters
    let digits = value.replace(/\D/g, "");

    // Format as (XXX) XXX-XXXX
    if (digits.length >= 10) {
      this.element.value = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    } else if (digits.length >= 6) {
      this.element.value = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
    } else if (digits.length >= 3) {
      this.element.value = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
    } else if (digits.length > 0) {
      this.element.value = `(${digits}`;
    }
  }
}
